import * as SearchResultsEffects from './search-results.effect';

export const effects = { ...SearchResultsEffects };
